import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { LinkSmall } from '@styled';

const MemberCallToAction = ({ url, graphID, onClick }) => {
    const history = useHistory();

    return (
        <div>
            <LinkSmall
                className="d-inline-block align-middle mr-2"
                href={url}
                onClick={e => {
                    onClick();

                    // History is undefined if called from within a modal
                    if (!history) {
                        return;
                    }

                    e.preventDefault();
                    history.push(url, { graphID });
                }}
            >
                View Profile
            </LinkSmall>
        </div>
    );
};

MemberCallToAction.propTypes = {
    url: PropTypes.string.isRequired,
    graphID: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default MemberCallToAction;
